<template>
  <span
    :class="loading || !canExportCsv ? 'text-muted' : ''"
    v-b-tooltip="upgradeTooltip"
  >
    {{ text }}
    <small v-if="!canExportCsv"><b-icon-lock-fill /></small>
  </span>
</template>
<script>
import ACCOUNT_QUERY from '@/graphql/AccountQuery.gql'
import PAGES_QUERY from '@/graphql/PagesQuery.gql'
import PAGE_LINKS_QUERY from '@/graphql/PageLinksQuery.gql'
import LINK_OPPORTUNITIES_QUERY from '@/graphql/LinkOpportunitiesQuery.gql'
import { get } from 'lodash'

export default {
  name: 'Csv',
  props: [
    'site',
    'where',
    'order',
    'text',
    'disabled',
    'fields',
    'name',
    'data'
  ],

  data: () => {
    return {
      loading: false,
      defaultFields: [
        'url',
        'title_score',
        'link_score',
        'status',
        'improved_at',
        'clicks',
        'site_clicks_delta',
        'potential',
        {
          label: 'original_title',
          value: 'title'
        },
        {
          label: 'draft_title',
          value: 'custom_title'
        },
        'optimized_title',
        'serp_title',
        'inbound_link_count',
        'outbound_link_count',
        'broken_links',
        'nofollow_links',
        'inbound_anchor_count'
      ]
    }
  },
  apollo: {
    account: {
      query: ACCOUNT_QUERY,
      fetchPolicy: 'cache-first'
    }
  },
  computed: {
    allFields() {
      return this.defaultFields.concat(this.fields || [])
    },
    canExportCsv() {
      if (this.$apollo.queries.account.loading) {
        return true
      }
      const stripeCustomer = get(this, 'account[0].stripe_customer')
      if (!stripeCustomer) {
        return false
      }
      return (
        (
          stripeCustomer.price.metadata.find((e) => e.name.includes('CSV')) ||
          {}
        ).value == 'true'
      )
    },
    upgradeTooltip() {
      return {
        disabled: this.canExportCsv,
        placement: 'left',
        title: `<a href="/account">Upgrade</a> to download CSVs`,
        html: true
      }
    }
  },
  methods: {
    async download() {
      if (!this.canExportCsv && !get(this, 'account[0].sudo_admin')) {
        return
      }
      this.loading = true
      let fields,
        pages = []
      if (this.name == 'anchortext') {
        fields = [
          'url',
          'title',
          'text',
          'score',
          'in_content',
          'is_image',
          'is_nofollow',
          'reasons'
        ]
        const { data } = await this.$apollo.query({
          query: PAGE_LINKS_QUERY,
          variables: this.where
        })
        data.links.forEach((l) => {
          l.page_links.forEach((pl) => {
            pages.push({
              ..._.omit(pl, ['page', 'reasons']),
              ...pl.page,
              reasons: pl.reasons.map((e) => e.name).join(', '),
              ..._.pick(l, 'text')
            })
          })
        })
        this.export(data.links, fields)
      } else if (this.name == 'link_opportunities') {
        fields = ['url', 'title', 'score', 'words']
        if (!this.data) {
          const { data } = await this.$apollo.query({
            query: LINK_OPPORTUNITIES_QUERY,
            variables: this.where
          })
          this.data = data.link_opportunities
        }
        pages = this.data.map((l) => ({
          ..._.omit(l, 'words'),
          words: l.words.map((e) => e.word).join(', ')
        }))
        this.export(pages, fields)
      } else {
        fields = this.allFields
        const { data } = await this.$apollo.query({
          query: PAGES_QUERY,
          variables: {
            where: this.where,
            order: this.order
          },
          fetchPolicy: 'no-cache'
        })
        this.export(data.pages, fields)
      }
    },
    async export(data, fields) {
      await this.$loadScript('https://cdnjs.cloudflare.com/ajax/libs/json2csv/5.0.7/json2csv.umd.min.js')
      const options = fields ? { fields } : undefined
      const json2csvParser = new json2csv.Parser(options)
      const csv = json2csvParser.parse(data)
      const $el = document.createElement('a')
      const filename = [
        'siteseer',
        this.site.url.replace(/([^\w]|https?)/g, ''),
        this.name,
        new Date().getFullYear(),
        new Date().getMonth() + 1,
        new Date().getDate()
      ].join('-')
      _zyppy.track('CSV Downloaded', { filename, label: filename })
      $el.download = filename + '.csv'
      $el.href = 'data:text/csv,' + encodeURIComponent(csv)

      document.body.appendChild($el)
      $el.click()
      document.body.removeChild($el)
      this.loading = false
    }
  }
}
</script>